<template>
  <div>
    <v-row no-gutters class="flex-nowrap">
      <v-col cols="4">
        <v-tabs vertical v-model="tab">
          <v-tab href="#info">Информация</v-tab>
          <v-tab v-if="showHandleTab" href="#handle">Управление заявкой</v-tab>
          <v-tab href="#logs" v-if="logList">Логи</v-tab>
          <v-tab href="#attachments">Вложения</v-tab>
          <v-tab href="#tasks">Обработка документов</v-tab>

          <v-divider />

          <v-tab disabled class="text-caption">Физ. лица</v-tab>

          <v-btn
            x-small
            plain
            @click="(fetchAppPersons().then(() => (lastTimestampFetchAppsPersons = Date.now())))"
            class="mb-2 d-inline"
          >
            <v-icon small>mdi-refresh</v-icon>
            {{ lastTimestampFetchAppsPersons === null ? 'Получить' : 'Обновить' }} список
          </v-btn>

          <template v-if="showFlTab">
            <v-tab
              v-for="person in fl"
              :key="person.id"
              class="text-subtitle-2"
              :href="'#person-' + person.id"
              :title="person.fullname"
            >
              <ApprovedIcon :person="person" />
              <span class="text-truncate">{{ person.fullname }}</span>
            </v-tab>
          </template>
          <template v-else-if="lastTimestampFetchAppsPersons !== null">
            <p class="font text--secondary text-subtitle-2 text-center pt-4 mb-2">Список физ. лиц пуст</p>
          </template>
        </v-tabs>

        <div class="ma-6 d-flex flex-column align-items-start" style="position: fixed; bottom: 0">
          <v-btn v-if="extra && extra.crm_source_type === 'Orchestrator'" color="success" class="mb-2" @click.stop="showActionsModal = true">Действия</v-btn>
          <AppActionsModal v-model="showActionsModal" />
          <v-btn v-if="allFilesLoaded" color="warning" class="mb-2" @click="sendFiles">Отправить документы</v-btn>
        </div>
      </v-col>
      <v-col class="ma-3">
        <v-tabs-items v-model="tab">
          <!-- Информация о компании -->
          <v-tab-item value="info">
            <AppCompanyTab />
          </v-tab-item>
          <v-tab-item v-if="showHandleTab" value="handle">
            <AppHandle />
          </v-tab-item>
          <!-- Логи -->
          <v-tab-item v-if="logList" value="logs">
            <AppLog />
          </v-tab-item>
          <!-- Документ -->
          <v-tab-item value="attachments">
            <AppDocument />
          </v-tab-item>
          <!-- Обработка документов -->
          <v-tab-item value="tasks">
            <AppDocumentProcess :show="tab === 'tasks' ? true : false" />
          </v-tab-item>

          <!-- Физ. лица -->
          <template v-if="showFlTab">
            <v-tab-item v-for="(person, i) in fl" :key="person.id" :value="'person-' + person.id">
              <AppFLTab :selectedPerson="i" />
            </v-tab-item>
          </template>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import AppCompanyTab from "@/components/apps/AppCompanyTab.vue";
import AppDocument from "@/components/apps/AppDocument.vue";
import AppFLTab from "@/components/apps/AppFLTab.vue";
import AppLog from "@/components/apps/AppLog.vue";
import AppHandle from "@/components/apps/AppHandle.vue";
import AppActionsModal from "@/components/apps/AppActionsModal.vue";
import ApprovedIcon from "@/components/common/ApprovedIcon.vue";


export default {
  name: "AppSidePanel",

  components: {
    AppCompanyTab,
    AppFLTab,
    AppLog,
    AppActionsModal,
    ApprovedIcon,
    AppDocument,
    AppDocumentProcess: () => import("@/components/apps/AppDocumentProcess.vue"),
    AppHandle
  },

  props: {
    closePanel: {
      type: Boolean,
    },
  },

  data() {
    return {
      tab: 0,
      showActionsModal: false,
      lastTimestampFetchAppsPersons: null
    };
  },

  methods: {
    ...mapActions("app", ["uploadLog", "resetApp", "resetAppCompany", "appTouch", "fetchAppPersons"]),

    sendFiles() {
      this.appTouch();
    },
  },

  watch: {
    closePanel(v) {
      if (v) {
        this.uploadLog();
      }
      if (!v) {
        this.tab = 0;
        this.resetAppCompany();
        this.lastTimestampFetchAppsPersons = null;
      }
    },
  },

  computed: {
    ...mapGetters("app", ["logList", "fl", "countDocs", "sourceState", "tasks", "extra"]),
    ...mapState("app", ["appCompany", "appId"]),

    allFilesLoaded() { // FIXME:
      if (!Array.isArray(this.fl)) return false;

      const notSended = this.fl.some((p) => p.sended === false);

      const allFlsFilesLoaded = this.fl.every(fl => {
        return fl.attachments?.every(attachment => {
          const isRequired = attachment.properties?.is_required ?? 0;
          if (isRequired) {
            return (attachment.files?.length ?? 0) !== 0;
          }

          return true;
        });
      });

      return allFlsFilesLoaded && notSended;
    },

    showFlTab() {
      return this.appCompany && this.fl && this.fl.length;
    },

    showHandleTab() {
      return this.sourceState === 'wait.cm';
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-tabs-bar__content {
  max-width: 100%;
}
</style>
